





















































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import { IContactPerson } from "@/interface";
import { AxiosResponse } from "axios";
import BaseMixin from "@/mixins/BaseMixin";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import NavigationTabs from "@/components/Customers/Customer/NavigationTabs.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Error404 from "@/components/Common/Error404.vue";

import swal from "sweetalert";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    AlertBox,
    NavigationTabs,
    Error404
  }
})
export default class CustomerContacts extends Mixins(BaseMixin) {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private contactPersons: Array<IContactPerson> = [];
  private noDataExist = false;
  private contactPersonsLength = 0;
  private failedRequest = false;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage: number | null = null;
  private perPage: number | null = null;
  private searchFilter = "";
  private selectedCustomerId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedCustomerId = vm.$route.params.customer_id;
      if (vm.$route.query.contact_person_deleted === "true") {
        swal("Success!", "The contact person was deleted.", "success").then(
          () => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }
        );
      }
      vm.getCustomerContactPersons(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.contact_person_deleted === "true") {
      swal("Success!", "The contact person was deleted.", "success").then(
        () => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        }
      );
    }
    this.forceRerender();
    if (
      this.perPage !== null &&
      this.to % this.perPage === 1 &&
      this.currentPage !== 1
    ) {
      this.currentPage -= 1;
    }
    this.getCustomerContactPersons(() => {
      //
    });
    next();
  }

  private mounted() {
    //
  }

  private getCustomerContactPersons(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId + "/contact-persons"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.contactPersons = response.data.data;
        /*this.currentPage = response.data.meta.current_page;
                  this.total = response.data.meta.total;
                  if (response.data.meta.from != null) {
                      this.from = response.data.meta.from;
                  } else {
                      this.from = 0;
                  }
                  if (response.data.meta.to != null) {
                      this.to = response.data.meta.to;
                  } else {
                      this.to = 0;
                  }
                  this.lastPage = response.data.meta.last_page;
                  this.perPage = response.data.meta.per_page;*/
        this.contactPersonsLength = this.contactPersons.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteCustomerContactPerson(contactPersonId: number): void {
    if (
      this.loading ||
      this.updating ||
      this.selectedCustomerId == null ||
      contactPersonId == null
    ) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The contact person will be deleted.",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "customers/" +
            this.selectedCustomerId +
            "/contact-persons/" +
            contactPersonId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "CustomerContacts",
                query: { contact_person_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal(
                    "Success!",
                    "The contact person was deleted.",
                    "success"
                  );
                  this.getCustomerContactPersons(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete contact persons.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.getCustomerContactPersons(() => {
        //
      });
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.getCustomerContactPersons(() => {
        //
      });
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.getCustomerContactPersons(() => {
        //
      });
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage) {
      if (this.lastPage !== null) {
        this.currentPage = this.lastPage;
      }
      this.getCustomerContactPersons(() => {
        //
      });
    }
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  private disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  private disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  private disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  private disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  @Watch("searchFilter")
  searchFilterChanged(): void {
    this.getCustomerContactPersons(() => {
      //
    });
  }
}
